import { makeAutoObservable } from "mobx";

import { Cell } from "./Cell";
import { Column } from "./Column";
import MealPlanFormStore from "./MealPlanFormStore";

export class Clipboard {
  mode?: "cell" | "column";
  copiedCell?: Cell;
  copiedColumn?: Column;

  private store: MealPlanFormStore;

  get label(): string {
    switch (this.mode) {
      case "cell":
        return this.copiedCell?.label ?? "";
      case "column":
        return this.copiedColumn?.label ?? "";
      default:
        return "";
    }
  }

  get isCopying(): boolean {
    return !!this.mode;
  }

  constructor(store: MealPlanFormStore) {
    makeAutoObservable(this);
    this.store = store;
  }

  clear(): void {
    this.mode = undefined;
    this.copiedCell = undefined;
    this.copiedColumn = undefined;
  }

  copyCell(cell: Cell): void {
    this.copiedCell = cell;
    if (this.copiedCell) this.mode = "cell";
  }

  copyColumn(dayColumn: Column): void {
    this.copiedColumn = dayColumn;
    if (this.copiedColumn) this.mode = "column";
  }

  pasteCell(targetCell: Cell): void {
    if (this.mode !== "cell" || !this.copiedCell) return;
    targetCell.copyFromCell(this.copiedCell);
  }

  pasteColumn(targetColumn: Column): void {
    if (this.mode !== "column" || !this.copiedColumn) return;

    this.store.cells.getDay(this.copiedColumn).forEach((cell, plannedMeal) => {
      const targetCell = this.store.cells.get(targetColumn, plannedMeal);
      targetCell.copyFromCell(cell);
    });
  }
}
